module.exports = __webpack_public_path__ + "static/media/inc_infected_myway.5ab494d7.svg";